module.exports = __webpack_public_path__ + "src/assets/img/car.7e39e088.svg";